import { DbLoaderHttp, RhybusError } from '@rhybus/api'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { apiPath, fetchProvider } from '../../assets/ts/api/api'
import { extractTextFromFileBuffer } from '../../assets/ts/pii/pii'
import { ExcelDropAreaResult } from '../../components/excel-drop-area/excel-drop-area.types'
import PageHeader from '../../layouts/header/page-header'
import { RoleContext } from '../../store/role-context-provider'
import * as rolesConfig from '../../utils/tools/roles-config'
import { FileOperation } from './appconfig.types'
import AppConfigSection from './appconfig-section'
import RolesInit from './roles-init'

async function handleFile(file: File, operation: FileOperation) {
  const dbLoader = new DbLoaderHttp(fetchProvider, apiPath)
console.log('')
  const formData = new FormData()
  formData.append('file', file)

  const result: ExcelDropAreaResult = {
    isError: false,
    message: '',
  }
  function constructRolesArray(data: string): { [key: string]: null | string }[] {
    const dataArray = JSON.parse(data.replace(/'/g, '"'))

    const headers = dataArray[0]
    const jsonArray: { [key: string]: null | string }[] = []

    for (let i = 1; i < dataArray.length; i++) {
      const row = dataArray[i]
      if (row.every((cell) => cell === null)) continue // Skip rows with all null values

      const rowData = {}
      for (let j = 0; j < headers.length; j++) {
        rowData[headers[j]] = row[j]
      }
      jsonArray.push(rowData)
    }

    return jsonArray
  }
  if (operation === 'loadRoles') {
    const rawRoles: any = await extractTextFromFileBuffer(file, 'xlsx')
    const formattedRoles = constructRolesArray(rawRoles)
    formattedRoles ? await rolesConfig.CreateCPTSRoles(formattedRoles) : ''
    if (formattedRoles.length > 0) {
      result.message = 'User Groups, Roles and Permission have successfully been Initialized'
    } else {
      result.message = 'User Groups, Roles and Permission Failed to Initialize'
    }
  } else {
    try {
      const apiResponse =
        operation === 'createIndexes'
          ? await dbLoader.createIndexes(formData)
          : operation === 'createLists'
          ? await dbLoader.addorupdatelists(formData)
          : operation === 'createViews'
          ? await dbLoader.addorupdateviews(formData)
          : operation === 'loadLists'
          ? await dbLoader.loadLists(formData)
          : `Unexpected server operation: ${operation}`

      result.message = JSON.stringify(apiResponse)
    } catch (ex) {
      console.error('Exception', ex)
      result.isError = true

      if (ex instanceof RhybusError) {
        result.message = `${ex.name}: ${ex.message}`
      } else {
        result.message = `An unkown error occurred:  ${JSON.stringify(ex)}`
      }
    }
  }

  return result
}

const AppConfig = () => {
  const navigate = useNavigate()
  const { firstLevelPermission, isLoading } = useContext(RoleContext)
  if (!isLoading) {
    if (!firstLevelPermission) {
      navigate('/accessdenied')
    }
  }
  return (
    <>
      <PageHeader name=' App Config' />

      <AppConfigSection
        dropAreaTitle='Drop List Creation File Here'
        processFileHandler={(file) => handleFile(file, 'createLists')}
        sectionTitle='▤ Create Lists'
      />

      <AppConfigSection
        dropAreaTitle='Drop Index Creation File Here'
        processFileHandler={(file) => handleFile(file, 'createIndexes')}
        sectionTitle='▤ Create Indexes'
      />

      <AppConfigSection
        dropAreaTitle='Drop List Load File Here'
        processFileHandler={(file) => handleFile(file, 'loadLists')}
        sectionTitle='▤ Load Lists'
      />
      <AppConfigSection
        dropAreaTitle='Drop View Creation  File Here'
        processFileHandler={(file) => handleFile(file, 'createViews')}
        sectionTitle='▤ Create Views'
      />
      <AppConfigSection
        dropAreaTitle='Drop User Groups and Permission File Here'
        processFileHandler={(file) => handleFile(file, 'loadRoles')}
        sectionTitle='▤ Initialize Roles'
      />
    </>
  )
}

export default AppConfig
